// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23cZ3","left":"styles_left__2UKQe"};